export default __webpack_public_path__ + "static/media/iphone.b5650a51.png";